<template>
    <div>
        <CCard class="p-3 border-radius-8px" style="border:none">
            <h3 class="custom-32px-600">Profile Setting</h3>
            <p class="custom-16px-400 font-color-98A2B3">Track orders list across your store.</p>
            <CTabs variant="pills" vertical>
                <CTab active>
                    <template slot="title">
                                      <img src="../assets/image/User.png" width="24px"> {{tabs[0]}}
</template>
                <div>
                    <CCard class="custom-border">
                        <h4 class="custom-16px-600">Company Name</h4>
                        <h4 class="custom-14px-400 font-color-98A2B3">
                            Enter the full legal name of your company as it appears on official documents.
                        </h4>
                        <input type="text" class="custom-bg-btn-white-border mt-2" style="width:100%"/>
                    </CCard>
                    <CCard class="custom-border">
                        <h4 class="custom-16px-600 mt-3">Company Overview</h4>
                        <div class="custom-14px-400 font-color-98A2B3">
                            Provide a brief description of your company's overview
                        </div>
                        <CTextarea rows="5" class="mt-2" value="Majlis Amanah Rakyat (MARA) or the Council of Trust for the People is an agency under the purview of Ministry of Regional and Rural Development established on 1 March 1966, as a corporate statutory body by an Act of Parliament as a result of the first Bumiputera Economic Congress in 1965.
MARA holds the responsibility to develop, encourage, facilitate, and implement the socioeconomic development and the society with focus on the rural area."/>
                    </CCard>
                    <CCard class="custom-border">
                        <h4 class="custom-16px-600">Company Logo</h4>
                        <CRow>
                            <CCol sm="3">
                                <img src="../assets/image/logoMara.png" width="50px"/>
                            </CCol>
                            <CCol sm="9">
                                <CCard class="custom-border-bg-grey text-center">
                                <div class="text-center" style="width:100%">
                                        <img src="../assets/image/logoUpload.png" width="30px"/>
                                        <p class="custom-16px-600 font-color-7F56D9 mt-3">Click here<label class="custom-16px-500 font-color-98A2B3 ml-2">to upload your file or drag.
                                      
                                        </label>
                                        <br />
                                    <label class="custom-16px-500 font-color-98A2B3">
                                            Supported Format: SVG, JPG, PNG (10mb each)
                                          </label></p>
                                        </div>
                                </CCard>
                                <div class="text-right">
                                    <CButton class="bg-white text-danger mr-2">Discard</CButton>
                                <CButton class="bg-7F56D9 text-white" @click="OpenAdd()">Save Changes</CButton>
                            </div>
                            </CCol>

                        </CRow>
                       
                     
                    </CCard>
                    </div>
              </CTab>
              <CTab>
<template slot="title">
    <img src="../assets/image/Lock.png" width="24px">
    {{tabs[1]}}
</template>

<h4 class="custom-16px-600">Change Password</h4>
<CCard class="custom-border">
    <h4 class="custom-16px-400 mt-3 font-color-98A2B3">Current Password</h4>
    <input type="password" class="custom-bg-btn-white-border mt-2" style="width:100%"/>
    <CRow>
        <CCol sm="6">
            <h4 class="custom-16px-400 mt-3 font-color-98A2B3">New Password</h4>
    <input type="password" class="custom-bg-btn-white-border mt-2" style="width:100%"/>
        </CCol>
        <CCol sm="6">
            <h4 class="custom-16px-400 mt-3 font-color-98A2B3">Confirm Password</h4>
    <input type="password" class="custom-bg-btn-white-border mt-2" style="width:100%"/>
        </CCol>
        <CCol sm="12">
            <h3 class="custom-16px-500 font-color-101828 text-left mt-3">Password Requirements:</h3>
            <ul class="font-color-98A2B3 custom-16px-400">
                <li>Minimum 8 characters long - the more, the better</li>
                <li>At least one lowercase character</li>
                <li>At least one number, symbol, or whitespace characte</li>
            </ul>
        </CCol>
    </CRow>
</CCard>
<h4 class="custom-16px-600">Two-steps Verification</h4>
<CCard class="custom-border">
    <h3 class="custom-16px-500 font-color-101828 text-left mt-3">Two factor authentication is not enabled yet.</h3>
    <p class="font-color-98A2B3 custom-16px-400">Two-factor authentication adds an additional layer of security to your account by requiring more than just a password to log in. Learn more.</p>
   
   <CRow class="p-2">
    <CButton class="bg-7F56D9 text-white">Enable two-factor authentication</CButton>
   </CRow>
   
</CCard>
              </CTab>
              <CTab>
<template slot="title">
    <img src="../assets/image/Bell.png" width="24px">
    {{tabs[2]}}
</template>
               
<h4 class="custom-16px-600">Notification Settings</h4>
<h4 class="custom-16px-400 mt-3 font-color-98A2B3">Manage your notification settings to receive relevant alerts and updates.</h4>
<CCard class="custom-border"> 
    <CRow>
        <CCol sm="10"> <h4 class="custom-16px-600">New Transaction</h4>
            <h4 class="custom-14px-400 font-color-98A2B3">Receive notifications for any new transaction in your account.</h4>
           </CCol>
        <CCol sm="2"> 
            <CSwitch class="mx-1 mt-3" color="primary" checked shape="pill" v-bind="labelIcon" />  
         </CCol>
         <CCol sm="12">
            <hr class="custom-hr" />
         </CCol>

         <CCol sm="10"> <h4 class="custom-16px-600">Login Alerts</h4>
            <h4 class="custom-14px-400 font-color-98A2B3">Be notified when your account is accessed from a new device.</h4>
           </CCol>
        <CCol sm="2"> 
            <CSwitch class="mx-1 mt-3" color="primary" checked shape="pill" v-bind="labelIcon" />  
         </CCol>
         <CCol sm="12">
            <hr class="custom-hr" />
         </CCol>

         <CCol sm="10"> <h4 class="custom-16px-600">Profile Updates</h4>
            <h4 class="custom-14px-400 font-color-98A2B3">Alerts for changes made to your profile, such as updating your email or phone number.</h4>
           </CCol>
        <CCol sm="2"> 
            <CSwitch class="mx-1 mt-3" color="primary" checked shape="pill" v-bind="labelIcon" />  
         </CCol>
         <CCol sm="12">
            <hr class="custom-hr" />
         </CCol>

         <CCol sm="10"> <h4 class="custom-16px-600">Email Notifications</h4>
            <h4 class="custom-14px-400 font-color-98A2B3">Enable or disable notifications sent to your email.</h4>
           </CCol>
        <CCol sm="2"> 
            <CSwitch class="mx-1 mt-3" color="primary" checked shape="pill" v-bind="labelIcon" />  
         </CCol>
         <CCol sm="12">
            <hr class="custom-hr" />
         </CCol>

    </CRow>
   
</CCard>

              </CTab>
            </CTabs>
            </CCard>
    </div>
 
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";
import _ from "lodash";
Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import { CChartDoughnut } from '@coreui/vue-chartjs'
import { CChartBar } from '@coreui/vue-chartjs'
import ToggleCard from '../components/Toggle.vue';

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import draggable from 'vuedraggable';

Vue.component("v-timepicker", VueTimepicker);
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        CChartDoughnut,
        CChartBar,
        ToggleCard,
        draggable

    },

    data() {
        return {
            tabs: [
                'Account',
                'Security',
                'Notifications'
            ],
            activeTab: 1,
            labelIcon: {
                labelOn: '\u2713',
                labelOff: '\u2715'
            },
            labelTxt: {
                labelOn: 'yes',
                labelOff: 'no'
            }



        }





    },
    async mounted() {

    },



    methods: {





    }

};
</script>

<style scoped>

</style>

